import { render, staticRenderFns } from "./refundOrderInfo.vue?vue&type=template&id=0dcd1f24&scoped=true"
import script from "./refundOrderInfo.vue?vue&type=script&lang=js"
export * from "./refundOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./refundOrderInfo.vue?vue&type=style&index=0&id=0dcd1f24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcd1f24",
  null
  
)

export default component.exports